import { Avatar, Divider, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Col from 'react-bootstrap/esm/Col';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/esm/Row';
import { CommentContent } from './CommentContent';
import moment from 'moment';
import { FiEdit } from 'react-icons/fi';
import Button from '@mui/material/Button';
import Slide from '@mui/material/Slide';
import { Modal } from 'react-bootstrap';
import { Update_Comment_Action } from '../Redux/Actions/Action_action';
import { useDispatch, useSelector } from 'react-redux';
import { Notify } from '../Utility/Notify';

export const CommentsCommponent = ({ comments, user, latestAssignment }) => {
  // إضافة latestAssignment كـ prop
  const theme = useTheme();
  const mode = theme.palette.mode;
  // console.log(comments, "comments in comments component")

  const dispatch = useDispatch();
  const [userlogin, setuserlogin] = useState('');
  const [filteredComments, setFilteredComments] = useState([]);
  const [commentsales, setcommentsales] = useState([]);

  useEffect(() => {
    if (JSON.parse(localStorage.getItem('user')) !== null) {
      setuserlogin(JSON.parse(localStorage.getItem('user')));
    }
  }, []);

  useEffect(() => {
    const refreshComments = () => {
      if (comments && Array.isArray(comments.Comments)) {
        // الفلترة الجديدة حسب latestAssignment
        const filtered = comments.Comments.filter((comment) => {
          // إذا لم يكن هناك إسناد أو clearHistory غير مفعل
          if (!latestAssignment?.clearHistory) return true;

          // التحقق من أن الكومنت تابع لليوزر الحالي
          const isCurrentUser = comment.sales?._id === userlogin.data?._id;

          // التحقق من التاريخ
          const commentDate = moment(comment.createdAt);
          const assignDate = moment(latestAssignment.assignDateTime);
          return isCurrentUser && commentDate.isAfter(assignDate);
        });

        setFilteredComments(filtered);
      } else {
        setFilteredComments([]);
      }

      if (comments && comments.leed && comments.leed.sales) {
        setcommentsales(comments.leed.sales);
      } else {
        setcommentsales([]);
      }
    };

    refreshComments();
    const interval = setInterval(refreshComments, 30000);
    return () => clearInterval(interval);
  }, [comments, latestAssignment, userlogin]); // إضافة التبعيات

  // باقي الدوال كما هي بدون تغيير
  const getCleanImageUrl = (url) => {
    if (!url) return null;
    const parts = url.split('/UsersImages/');
    return parts.length > 2 ? `${parts[0]}/UsersImages/${parts[2]}` : url;
  };

  const profileImage = filteredComments[0]?.sales?.profileImg
    ? getCleanImageUrl(filteredComments[0]?.sales?.profileImg)
    : null;

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [selectedComment, setSelectedComment] = useState(null);
  const [commentText, setCommentText] = useState(''); // لتعديل النص
  const [nextactionText, setnextactionText] = useState(''); // لتعديل النص

  const handleClickOpen = (comment) => {
    setSelectedComment(comment);
    setCommentText(comment.firstcomment?.text || '');
    setnextactionText(comment.secondcomment?.text || '');
    setShow(true);
    // console.log("Selected Comment", comment._id);
  };

  const [loading, setloading] = useState(false);

  const handleEdit = async () => {
    if (!selectedComment) {
      console.error('No comment selected!');
      return;
    }

    const commentId = selectedComment._id; // ← هذا هو ID الكومنت الصحيح
    // console.log("Edit Comment", commentId, selectedComment);

    try {
      setloading(true);
      await dispatch(
        Update_Comment_Action(commentId, {
          firstText: commentText,
          secondText: nextactionText,
        }),
      );
      setloading(false);
    } catch (error) {
      console.error('Update failed', error);
    } finally {
      setShow(false); // إغلاق المودال بعد النجاح أو الفشل
    }
  };

  const resupdate = useSelector((state) => state.AllActions.Action);

  useEffect(() => {
    if (loading === false) {
      if (resupdate && resupdate.status === 200) {
        Notify('success', 'Comment Updated Successfully', 'success');
      }
    }
  }, [loading]);

  return (
    <Container style={{ width: '100%', background: '#fff' }}>
      {/* ======================================================================edit comment */}
      <Modal show={show} onHide={handleClose} style={{ zIndex: '20000' }}>
        <Modal.Header
          closeButton
          style={{
            color: mode === 'dark' ? '#90caf9' : '#666',
            backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
          }}
        >
          <Modal.Title>Update Comment And Next Action Data...</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            color: mode === 'dark' ? '#90caf9' : '#666',
            backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
          }}
        >
          <div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
              <label style={{ color: mode === 'dark' ? '#90caf9' : '#666', fontWeight: 'bold' }}>
                First Comment
              </label>
              <input
                style={{
                  width: '100%',
                  height: '100px',
                  borderRadius: '10px',
                  padding: '10px',
                  background: '#f0f0f0',
                  color: '#000',
                }}
                placeholder="Write Your Comment Here..."
                value={commentText}
                onChange={(e) => setCommentText(e.target.value)}
              />

              <label style={{ color: mode === 'dark' ? '#90caf9' : '#666', fontWeight: 'bold' }}>
                Next Action
              </label>
              <input
                style={{
                  width: '100%',
                  height: '100px',
                  borderRadius: '10px',
                  padding: '10px',
                  background: '#f0f0f0',
                  color: '#000',
                }}
                placeholder="Write Your Next Action Here..."
                value={nextactionText}
                onChange={(e) => setnextactionText(e.target.value)}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer
          style={{
            color: mode === 'dark' ? '#90caf9' : '#666',
            backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
          }}
        >
          <Button
            style={{ background: '#fff', color: '#102dff', border: '#102dff' }}
            onClick={handleClose}
          >
            Close
          </Button>
          <Button style={{ background: '#102dff', color: '#fff' }} onClick={handleEdit}>
            Apply Edit
          </Button>
        </Modal.Footer>
      </Modal>
      {/* =============================================================================== */}

      <Row style={{ marginTop: '10px' }} className="w-100">
        <Col xs={12} md={6}>
          <div className="d-flex justify-content-between align-items-start w-100">
            {/* الصورة والاسم */}
            <div className="d-flex align-items-center gap-2">
              <Avatar
                alt={filteredComments[0]?.sales?.name || 'Sales Avatar'}
                src={profileImage}
                sx={{ width: 40, height: 40 }}
              />
              <div style={{ lineHeight: '1.2' }}>
                <div style={{ fontWeight: '600', fontSize: '16px', color: '#1a1a1a' }}>
                  {filteredComments[0]?.sales?.name}
                </div>
                <div style={{ fontSize: '14px', color: '#666' }}>
                  {filteredComments[0]?.sales?.role || 'Sales'}
                </div>
              </div>

              {/* زر Edit */}
              {userlogin?.data?.role === 'Admin' && (
                <button
                  className="btn btn-outline-primary d-flex justify-content-end    py-2  shadow-sm"
                  style={{
                    fontWeight: '500',
                    fontSize: '15px',
                    background: '#102dff',
                    color: 'white',
                    border: 'none',
                    borderRadius: '5px',
                  }}
                  onClick={() => handleClickOpen(filteredComments[0])}
                >
                  <FiEdit size={18} />
                  Edit
                </button>
              )}
            </div>
          </div>
        </Col>

        {filteredComments.length > 0 ? (
          filteredComments.map((item, index) => (
            <Col xs={12} md={10} style={{ borderRadius: '10px', width: '100%' }} key={index}>
              <CommentContent
                comment={item}
                commentsales={commentsales}
                user={user}
                showDate={!latestAssignment?.clearHistory} // التحكم في إظهار التاريخ
              />
            </Col>
          ))
        ) : (
          <div className="text-white text-center w-100 py-3">
            {latestAssignment?.clearHistory
              ? 'لا توجد تعليقات بعد تاريخ الإسناد'
              : 'لا توجد تعليقات متاحة'}
          </div>
        )}

        <Divider style={{ color: 'white' }} />
      </Row>
      <hr style={{ border: '2px solid #666' }} />
    </Container>
  );
};
